import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionResponseUpdateInput } from '../generated/globalTypes';
import { updateQuestionResponseMutation, updateQuestionResponseMutationVariables } from '../generated/updateQuestionResponseMutation';
import { questionResponseFieldsFragment } from '../models/QuestionResponse';

/**
 * Get a callback to update a QuestionResponse in the store.
 */
export function useUpdateQuestionResponseCallback(): [(id: string, model: QuestionResponseUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateQuestionResponseMutation, updateQuestionResponseMutationVariables>(
        gql`
            mutation updateQuestionResponseMutation ($model: QuestionResponseUpdateInput!) {
                updateQuestionResponse(model: $model) {
                    ...questionResponseFields
                }
            }

            ${questionResponseFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: QuestionResponseUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
